import { Component, Input } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { IAppState } from '../app.state';
import { Meta } from '../../angular2-meta';

import { selectShare, selectItem } from './share.actions';
import { selectCurrentAttachment, unselectCurrentAttachment } from './attachment.actions';

import {selectCurrentAttachment as selectCurrentAttachmentModel, selectCurrentNote, selectCurrentShare} from './models';
import { selectVisual } from '../visual/visual.selector';

@Component({
  selector: 'nns-attachment',
  template: `
    <div
      class="attachment-holder"
      flex
      layout="column"
      *ngIf="currentAttachment$ | async; else notFound; let attachment"
    >
      <nns-image-attachment
        flex="noshrink" layout="row" layout-align="center center"
        [attachment]="attachment"
        [share]="share$ | async"
        [note]="currentNote$ | async"
        *ngIf="attachment.type=='image'"
      ></nns-image-attachment>
      <nns-video-attachment
        flex="noshrink" layout="column" layout-align="center center"
        [attachment]="attachment"
        [share]="share$ | async"
        [note]="currentNote$ | async"
        [visual]="(visual$ | async)"
        *ngIf="attachment.type=='video'"
      ></nns-video-attachment>
      <nns-audio-attachment
        flex="noshrink" layout="column" layout-align="center center"
        [attachment]="attachment"
        [share]="share$ | async"
        [note]="currentNote$ | async"
        *ngIf="attachment.type=='audio'"
      ></nns-audio-attachment>
    </div>
    <ng-template #notFound>
      <nns-error flex="noshrink"></nns-error>
    </ng-template>
  `,
  styles: [`
    :host {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      flex: 1 1 auto;
      min-height: 1px;
    },
    :host-context(.no-flex) :host {
      display:inline-block;
    }

    .attachment-holder {
      position: relative;
    }

    nns-close-attachment {
      position: absolute;
      right: 16px;
      top: 16px;
    }
  `, `
   :host-context(.nns-theme-night) .attachment-holder {
      background:#2f3737;
    }
  `]
})
export class AttachmentComponent {
  public attachmentId;
  public currentAttachment$;
  public urlString;
  visual$;
  share$;
  currentNote$;

  constructor(
    public _route: ActivatedRoute,
    public _store: Store<IAppState>,
    public _meta: Meta
  ) {
    this._route.params.forEach((params: Params) => {
      const shareId = params.shareId;
      const securityKey = params.securityKey;
      const nodeId = params.nodeId;

      this.attachmentId = params.attachmentId;

      this._store.dispatch(selectShare(shareId, securityKey));
      this._store.dispatch(selectItem(nodeId));
      this._store.dispatch(selectCurrentAttachment(this.attachmentId));

      this.urlString = `/share/${shareId}/${securityKey}/${nodeId}`;
    });

    this.currentAttachment$ = this._store.pipe(select(selectCurrentAttachmentModel));
    this.visual$ = this._store.pipe(select(selectVisual));
    this.share$ = this._store.pipe(select(selectCurrentShare));
    this.currentNote$ = this._store.pipe(select(selectCurrentNote));
  }

  ngOnDestroy() {
    this._store.dispatch(unselectCurrentAttachment());
  }
}
